import './_baseGetTag.js';
import { _ as _nodeUtilExports } from './_nodeUtil.js';

var nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
nodeUtil && nodeUtil.isDate;
